import React, { FC } from 'react';

import { Box, HStack } from '@chakra-ui/react';

import { DottedUnderlineLink } from 'components/DataDisplay';
import { CustomTooltip } from 'components/DataDisplay/Tooltip/CustomTooltip';

import { FormLabelProps } from '../types';

export const FormLabel: FC<FormLabelProps> = props => {
  const {
    label,
    isRequired,
    helpIcon,
    styles = {},
    helpTooltip,
    htmlFor,
    helpLabel,
    onClickHelpIcon,
  } = props;

  return (
    <HStack
      mb={2}
      justify={helpLabel ? 'space-between' : styles?.justifyContent}
    >
      <HStack spacing={0} align="center">
        <Box htmlFor={htmlFor} color="gray.300" {...styles}>
          {label}
        </Box>
        {isRequired ? <Box color="red">*</Box> : ''}
      </HStack>
      {helpIcon &&
        (helpTooltip ? (
          <CustomTooltip label={helpTooltip}>
            <Box
              boxSize={4}
              onClick={onClickHelpIcon}
              cursor={onClickHelpIcon ? 'pointer' : 'inherit'}
              color="primary"
              userSelect={'none'}
            >
              {helpIcon}
            </Box>
          </CustomTooltip>
        ) : (
          <Box
            onClick={onClickHelpIcon}
            cursor={onClickHelpIcon ? 'pointer' : 'inherit'}
          >
            {helpIcon}
          </Box>
        ))}
      {helpLabel && (
        <DottedUnderlineLink onClick={onClickHelpIcon} label={helpLabel} />
      )}
    </HStack>
  );
};
